module.exports = __webpack_public_path__ + "static/media/iconView.bf715ab6.svg";